/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { IAssetDto } from '../Asset.model'
import { Link } from 'react-router-dom'
import { IconLabelContent } from '../../../common/component/IconLabelContent'
import { useIntl } from 'react-intl'

interface Props {
  data: IAssetDto
}

export const AssetInnerListItem: FC<Props> = ({
  data,
}: Props) => {
  const intl = useIntl()

  const buildClientDescriptionLine = (data: IAssetDto) => {
    let description = `${data.client.displayName}`

    if (data.address) {
      description += description ? ` | ${data.address}` : `${data.address}`
    }
    return description
  }

  const buildAssetDescriptionLine = (data: IAssetDto) => {
    return `${data.family} | ${data.area} | ${data.brand} | ${data.model} | ${data.serial}`
  }

  return (
    <Link to={`/assets/${data.id}`} target='_blank'>
      <div className='bg-hover-light-primary py-2'>
        <div className='d-flex flex-stack'>
          <div className='d-flex align-items-center'>
            <div className='ms-2'>
              <div className='fs-7 cursor-pointer'>
                <span className='fw-bolder mb-2'>{data.displayName}</span>
                <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
                <span className='text-primary mb-2'>{data.sequence}</span>
              </div>

              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{buildClientDescriptionLine(data)}</span>
                </div>
              </div>

              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{buildAssetDescriptionLine(data)}</span>
                </div>
              </div>

              <div className='d-flex justify-content-start align-items-center'>
                <IconLabelContent
                  title={
                    data.contract
                      ? `${intl.formatMessage({id: 'UTIL.CONTRACT'})} ${data.contract.sequence}`
                      : ''
                  }
                  active={!!data.contract}
                  icon='bi bi-vector-pen'
                />

                <IconLabelContent
                  title={`${intl
                    .formatMessage({id: 'TITLE.REPORT.TOTAL'})
                    .replace(/%s/g, `${data.totalReport > 0 ? data.totalReport : 0}`)}`}
                  labelValue={`${data.totalReport || ''}`}
                  active={data.totalReport > 0}
                  icon='bi bi-speedometer'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
